import { BaseEnum, enumToSelectOptions, enumCodeToLabel } from "../BaseEnum";

export class DsrUploadedDocumentType extends BaseEnum {
  static WATER = 1;
  static GOODS_AND_SERVICES = 2;
  static ELECTRICITY = 3;
  static FLEET = 4;
  static GAS = 5;
  static PROCESSES = 6;
  static WASTE = 7;
  static DISTRICT_HEATING = 8;
  static FUEL = 9;
  static OTHER = 99;

  static Enabled = [
    false,
    false,
    true,
    true,
    true,
    false,
    false,
    true,
    true,
    false,
  ];

  static AllowedExtensions = [
    ["pdf"],
    ["pdf"],
    ["pdf"],
    ["xlsx", "xls"],
    ["pdf"],
    ["pdf"],
    ["pdf"],
    ["pdf"],
    ["xlsx", "xls", "pdf"],
    ["pdf"],
  ];

  static Codes = [
    this.WATER,
    this.GOODS_AND_SERVICES,
    this.ELECTRICITY,
    this.FLEET,
    this.GAS,
    this.PROCESSES,
    this.WASTE,
    this.DISTRICT_HEATING,
    this.FUEL,
    this.OTHER,
  ];

  static _labelKeys = [
    "enums.dsr-uploaded-document-type.WATER",
    "enums.dsr-uploaded-document-type.GOODS_AND_SERVICES",
    "enums.dsr-uploaded-document-type.ELECTRICITY",
    "enums.dsr-uploaded-document-type.FLEET",
    "enums.dsr-uploaded-document-type.GAS",
    "enums.dsr-uploaded-document-type.PROCESSES",
    "enums.dsr-uploaded-document-type.WASTE",
    "enums.dsr-uploaded-document-type.DISTRICT_HEATING",
    "enums.dsr-uploaded-document-type.FUEL",
    "enums.dsr-uploaded-document-type.OTHER",
  ];

  static toSelectOptions(from, to, onlyActive = true) {
    if (onlyActive) {
      let filteredCodes = [];
      let filteredLabels = [];
      for (let i = 0; i < this.Codes.length; i++) {
        if (this.Enabled[i]) {
          filteredCodes.push(this.Codes[i]);
          filteredLabels.push(this.Labels[i]);
        }
      }
      return enumToSelectOptions(filteredCodes, filteredLabels, from, to);
    }
    return enumToSelectOptions(this.Codes, this.Labels, from, to);
  }

  static codeToAllowedExtensions(code) {
    return enumCodeToLabel(this.Codes, this.AllowedExtensions, code);
  }
}
